import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AuthProvider } from '@ddone/auth';
import { ErrorState, LoadingScreen, ThemeProvider, ToastProvider } from '@ddone/ui';
import '@ddone/ui/styles.css';
import './styles/app.css';
import './i18n';
import { router } from './router';
import { LoginScreen } from './shell/login-screen';
import { InitialSetupScreen } from './shell/initial-setup-screen';
import { AcceptInvitationScreen } from './shell/accept-invitation-screen';
import { DesktopRuntimeProvider } from './desktop/desktop-runtime';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 20_000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: false }
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('Elemento #root non trovato');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <DesktopRuntimeProvider>
        <ThemeProvider>
          <ToastProvider>
            <AuthProvider
              loading={<LoadingScreen label="Apertura del workspace…" />}
              unauthenticated={<LoginScreen />}
              setup={(session, refreshSession) =>
                window.location.pathname === '/accept-invite' ? (
                  <AcceptInvitationScreen onComplete={refreshSession} standalone />
                ) : (
                  <InitialSetupScreen session={session} onComplete={refreshSession} />
                )
              }
              error={(error, retry) => (
                <main className="dd-standalone-state">
                  <ErrorState
                    title="DDone non è raggiungibile"
                    message={error instanceof Error ? error.message : 'Errore di connessione'}
                    onRetry={retry}
                  />
                </main>
              )}
            >
              <RouterProvider router={router} />
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </DesktopRuntimeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
